import { useLanguage } from 'assets/languages';
import Checkbox, { CheckboxProps, ICON_TYPES } from 'components/checkbox';
import CampaignFormField, {
  CampaignFormFieldProps,
} from '../../../../../campaignFormFieldGroup/components/campaignFormField/campaignFormField';

type NeedGuidelineRuleFieldProps = Pick<CampaignFormFieldProps, 'label'> &
  Pick<CheckboxProps, 'checked'> & {
    onClick: (value: boolean) => void;
  };

const NeedGuidelineRuleField = ({
  label,
  checked,
  onClick,
}: NeedGuidelineRuleFieldProps) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };

  return (
    <CampaignFormField label={label}>
      <div className="flex flex-row gap-[20px]">
        <Checkbox
          type={ICON_TYPES.CIRCLE}
          text={languageTexts.campaign_form_need_guideline_rule_field_true}
          checked={checked}
          onClick={() => onClick(true)}
        />
        <Checkbox
          type={ICON_TYPES.CIRCLE}
          text={languageTexts.campaign_form_need_guideline_rule_field_false}
          checked={!checked}
          onClick={() => onClick(false)}
        />
      </div>
    </CampaignFormField>
  );
};

export default NeedGuidelineRuleField;
